import { render, staticRenderFns } from "./CustomersViewTable.vue?vue&type=template&id=0efbc8f4&scoped=true&lang=pug&"
import script from "./CustomersViewTable.vue?vue&type=script&lang=js&"
export * from "./CustomersViewTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomersViewTable.vue?vue&type=style&index=0&id=0efbc8f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efbc8f4",
  null
  
)

export default component.exports